// Takes a collection type and the user's role.
function GrabElement(data, role) {
  //console.log(data);

  //   Make sure we have the right data.
  if (!data || data.length === 0) return null;

  // Return element upon finding a role with the same name.
  return data.find((element) => {
    return element.attributes.role === role;
  });
}

export default GrabElement;
